/**
 * Project window guard (Bill, 2026-08-03): a subtask date may not fall before
 * the project's kick-off date. The rule WARNS and allows an override - the
 * caller passes the confirmed override to the API as `allowBeforeKickoff`.
 *
 * A project with no kickoffDate has no window, so nothing is checked.
 */

/** True when `date` (YYYY-MM-DD) falls before the kick-off date. */
export function isBeforeKickoff(date, kickoffDate) {
    if (!date || !kickoffDate) return false;
    return date < kickoffDate;
}

/**
 * Warn once for a date change, and return whether the caller may proceed.
 * Returns { proceed, override } - `override` is true only when the user
 * accepted a pre-kickoff date, and must be sent on to the API.
 */
export function confirmProjectWindow({ start, dueDate, kickoffDate, label }) {
    const offending = [];
    if (isBeforeKickoff(start, kickoffDate)) offending.push(`a start date of ${start}`);
    if (isBeforeKickoff(dueDate, kickoffDate)) offending.push(`an end date of ${dueDate}`);
    if (offending.length === 0) return { proceed: true, override: false };

    const proceed = window.confirm(
        `Warning: ${label} would have ${offending.join(' and ')}, ` +
        `before the project start date of ${kickoffDate}.\n\n` +
        `Continue anyway?`
    );
    return { proceed, override: proceed };
}
